import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

function s(...r){return twMerge(clsx(r))}function i(r){return `${r}%`}

export { s as a, i as b };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-5HWZQ4DE.js.map